import { pageLinkEnum } from 'models/common.models'
import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Form, FormControl, InputGroup } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router'

const HeaderSearchBox = (props) => {
	let { pathname } = useLocation()
	const history = useHistory()
	const [pageLink, setPageLink] = useState(0)
	const [searchText, setSearchText] = useState('')

	useEffect(() => {
		if (pathname === '/meeting') {
			setPageLink(0)
			setSearchText('')
		}
	}, [pathname])

	const handleSearch = (e) => {
		e.preventDefault()
		if (Number(pageLink) === 1) {
			history.push(`${pageLinkEnum[1].link}${searchText}`)
		} else {
			window.location.href = !props.featureFlag?.WcmsNavIntegration ? `${pageLinkEnum[0].link}${searchText}` : `${pageLinkEnum[4].link}${searchText}`;
		}
	}

	return (
		<div data-testid="search-cmp">
			<Form className="astm-form" onSubmit={handleSearch}>
				<InputGroup>
					<InputGroup.Prepend>
						<Form.Group>
							<Dropdown aria-label="basic search" value={pageLink} name='pageLink'
								onSelect={(eventKey) => setPageLink(eventKey)}>
								<Dropdown.Toggle variant="Primary" id="dropdown-basic">
									{pageLinkEnum[pageLink].label}
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item eventKey={pageLinkEnum[0].value}>{pageLinkEnum[0].label}</Dropdown.Item>
									<Dropdown.Item eventKey={pageLinkEnum[1].value}>{pageLinkEnum[1].label}</Dropdown.Item>
									<Dropdown.Item eventKey={pageLinkEnum[2].value}>{pageLinkEnum[2].label}</Dropdown.Item>
									<Dropdown.Item eventKey={pageLinkEnum[3].value}>{pageLinkEnum[3].label}</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</Form.Group>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search topic, title, author, A53 ..."
						aria-label="basic search text box"
						aria-describedby="basic-search"
						name='searchText'
						data-testid="header-search-box"
						defaultValue=""
						value={searchText}
						onChange={(e) => setSearchText(e.target.value)}
					/>
					<InputGroup.Append>
						<Button type="submit" variant="primary" aria-label="Search" disabled={!searchText}>
							<i className="fas fa-search"></i>
							<span className="goMobile">Go</span>
						</Button>
					</InputGroup.Append>
				</InputGroup>
			</Form>
		</div>
	)
}

export default HeaderSearchBox
